import _defaultTo from 'lodash/defaultTo';
import _get from 'lodash/get';
import _orderBy from 'lodash/orderBy';
import _toUpper from 'lodash/toUpper';
// Serialization
import { deserialize, serialize } from 'serializr';
import { deviceModelSchema } from './schemas';

/**
* Serialization
*/
const serializerKey = 'device_model';

const deserializeDeviceModel = (data) => deserialize(deviceModelSchema, data);

const serializeDeviceModel = ({
  type, version, name, productible,
}) => ({
  [serializerKey]: {
    ...serialize(deviceModelSchema, {
      type: _defaultTo(type, null),
      version: _defaultTo(version, null),
      name: _defaultTo(name, null),
      productible: _defaultTo(productible, null),
    }),
  },
});

/**
* Utils
*/
const sortDeviceModels = (deviceModels, fields = ['type', 'version'], dirs = ['asc', 'asc']) => (_orderBy(deviceModels, fields, dirs));

const deviceModelTitle = (deviceModelData) => _get(deviceModelData, 'name', '');
const deviceModelDesc = (deviceModelData) => `${_toUpper(_get(deviceModelData, 'type', ''))} ${_get(deviceModelData, 'version', '')}`;

/**
* Model
*/
const deviceModel = {
  // Name and icon
  name: 'deviceModel',
  icon: 'deviceModel',

  // Constants
  TYPES: {
    opac: 'opac',
    opacSlave: 'opac_slave',
  },

  // Serialization
  deserialize: deserializeDeviceModel,
  serialize: serializeDeviceModel,

  // Sort elements
  sortElements: sortDeviceModels,

  // Utils
  title: deviceModelTitle,
  desc: deviceModelDesc,
};

module.exports = deviceModel;



// WEBPACK FOOTER //
// ./models/deviceModel.js